"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _HYJVIPVIcjs = require('./HYJVIPVI.cjs');


var _OTCKJ4OKcjs = require('./OTCKJ4OK.cjs');




var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/hovercard/hovercard-dismiss.tsx
var TagName = "button";
var useHovercardDismiss = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useHovercardDismiss2({ store, ...props }) {
    const context = _OTCKJ4OKcjs.useHovercardScopedContext.call(void 0, );
    store = store || context;
    props = _HYJVIPVIcjs.usePopoverDismiss.call(void 0, { store, ...props });
    return props;
  }
);
var HovercardDismiss = _PTOCUU2Dcjs.forwardRef.call(void 0, function HovercardDismiss2(props) {
  const htmlProps = useHovercardDismiss(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});




exports.useHovercardDismiss = useHovercardDismiss; exports.HovercardDismiss = HovercardDismiss;
